import { LOGOUT } from '@shared/duck/actions';

import resetOnActions from './resetOnActionsReducer';

export default reducer => resetOnActions(reducer, LOGOUT);
